export default {
    when() {
        //return $('.card--segments').length > 0;
    },

    mounted() {
        let allButtonsViewMore = document.querySelectorAll('.button-view-more');
        let allButtonsViewLess = document.querySelectorAll('.button-view-less');
        let allSegments = document.querySelectorAll('.card--segments');

        allButtonsViewMore.forEach(button => {
            button.addEventListener('click', () => {

                allSegments.forEach(segment => {
                    console.log(segment.getBoundingClientRect().top)
                    if (segment.getBoundingClientRect().top == button.parentElement.getBoundingClientRect().top) {

                        segment.querySelector('.link-read-more').style.display = 'block';
                        let accordionContentHeight = segment.querySelector('.segments__bottom').scrollHeight;
                        segment.querySelector('.segments__bottom').style.maxHeight = accordionContentHeight + "px";
                        segment.querySelector('.button-view-less').style.display = 'block';
                        segment.querySelector('.button-view-more').style.display = 'none';

                    }
                })


            })
        })
        allButtonsViewLess.forEach(button => {
            button.addEventListener('click', () => {
                allSegments.forEach(segment => {
                    if (segment.getBoundingClientRect().top == button.parentElement.getBoundingClientRect().top) {

                        segment.querySelector('.link-read-more').style.display = 'none';
                        segment.querySelector('.segments__bottom').style.maxHeight = "0px";
                        segment.querySelector('.button-view-more').style.display = 'block';
                        segment.querySelector('.button-view-less').style.display = 'none';

                    }
                })
            })
        })
    },
};
